<template>
  <div id="app">
    <toppage-item v-if="!flag" ref="child"></toppage-item>
    <toppage-item2 v-else v-show="$route.name == 'index6'||$route.name == 'index7'||$route.name == 'index8'||$route.name == 'index9'||$route.name == 'index10'" ref="child"></toppage-item2>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <footpage-item v-if="!flag"></footpage-item>
    <footpage-item2 v-else></footpage-item2>
    <el-backtop :bottom="100" v-if="!flag">
        <div
        style="{
            height: 50px;
            width: 50px;
            background-color: #C8161D;
            box-shadow: 0 0 6px rgba(0,0,0, .12);
            text-align: center;
            color: #1989fa;
            padding: 5px;
            border-radius: 2px;
        }"
        >
        <i class="el-icon-arrow-up clf" style="font-size: 40px;"></i>
        </div>
    </el-backtop>
    <el-backtop :bottom="50" v-else>
        <div
        style="{
            height: 0.6rem;
            width: 0.6rem;
            background-color: #C8161D;
            box-shadow: 0 0 0.1rem rgba(0,0,0, .12);
            text-align: center;
            color: #1989fa;
            padding: 0.06rem;
            border-radius: 0.06rem;
        }"
        >
        <i class="el-icon-arrow-up clf" style="font-size: 0.6rem;"></i>
        </div>
    </el-backtop>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
        mune_list: [{id: 1, name: '首页', page: 'index', icon: 'el-icon-house'},
            {id: 2, name: '关于我们', page: 'index2', icon: 'el-icon-user'},
            {id: 3, name: '合作伙伴', page: 'index3', icon: 'el-icon-trophy'},
            {id: 5, name: '最新资讯', page: 'index5', icon: 'el-icon-document'},
            {id: 4, name: '加入我们', page: 'index4', icon: 'el-icon-chat-line-square'},
            {id: 6, name: '首页', page: 'index6', icon: 'el-icon-house'},
            {id: 7, name: '关于我们', page: 'index7', icon: 'el-icon-user'},
            {id: 8, name: '合作伙伴', page: 'index8', icon: 'el-icon-trophy'},
            {id: 9, name: '最新资讯', page: 'index9', icon: 'el-icon-document'},
            {id: 10, name: '加入我们', page: 'index10', icon: 'el-icon-chat-line-square'},
            ],
            flag: false
    }
  },
  mounted() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    this.flag = flag;
    if (flag) {
      if(this.$route.name=='index'||this.$route.name=='index2'||this.$route.name=='index3'||this.$route.name=='index4'||this.$route.name=='index5'||this.$route.name=='allstore'||this.$route.name=='bigshotinfo'||this.$route.name=='bigshotlist'||this.$route.name=='storeinfo'||this.$route.name=='articledetails') {
        this.$router.replace('/index66');
      }
    } else {
      if(this.$route.name=='index6'||this.$route.name=='index7'||this.$route.name=='index8'||this.$route.name=='index9'||this.$route.name=='index10'||this.$route.name=='allstore2'||this.$route.name=='bigshotinfo2'||this.$route.name=='bigshotlist2'||this.$route.name=='storeinfo2'||this.$route.name=='articledetails2') {
        this.$router.replace('/');
      }
    }
	},
  updated() {
    var list = this.mune_list;
    for (let i = 0; i < list.length; i++) {
      if(this.$route.name == list[i].page) {
        this.$refs.child.sing(list[i].id);
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if(to.name!='index'&&to.name!='index2'&&to.name!='index3'&&to.name!='index4'&&to.name!='index5'&&to.name!='index6'&&to.name!='index7'&&to.name!='index8'&&to.name!='index9'&&to.name!='index10') {
        this.$refs.child.sing();
      } else {
        var list = this.mune_list;
        for (let i = 0; i < list.length; i++) {
          if(to.name == list[i].page) {
            this.$refs.child.sing(list[i].id);
          }
        }
      }
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-tabs__item.is-active {
  color: #C8161D;
}

.el-tabs__item:hover {
  color: #C8161D;
}
.el-tabs__active-bar{
  background-color: #C8161D;
}
.el-carousel__arrow{
    width: 0.5rem;
    height: 0.5rem;
    background-color: rgba(31,45,61,.3);
    font-size: 0.2rem;
}
.router-linkz{
  text-decoration: none;
}
.el-backtop{
  width: 0;
  height: 0;
}
.el-tabs__item{
    padding: 0 0.26rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue